import { useQuery } from 'react-query';

import {
  PairingsResponse,
  TournamentOwnerPairingsArgs,
} from '~/../api/common.types';
import { api } from '~/client/api';

export const useGetTournamentOwnerPairings = ({
  data,
  enabled,
}: {
  data: TournamentOwnerPairingsArgs;
  enabled: boolean;
}) => {
  // return useQuery<PairingsResponse>(['getTournamentOwnerPairings', data] => {
  //   return api.getTournamentOwnerPairings(data);
  // });

  return useQuery<PairingsResponse | undefined, Error>(
    ['products', data],
    () => api.getTournamentOwnerPairings(data),
    {
      // staleTime: 60 * 1000 * 5,
      enabled,
    }
  );
};
